import axios from "axios";
import { ensureHttps } from "@/lib/https";

function backendUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  if (process.env.NODE_ENV === "production" && (!raw || /localhost|127\.0\.0\.1/.test(raw))) {
    return "";
  }
  return ensureHttps(raw);
}

const BACKEND_URL = backendUrl();
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail, fallback) {
  if (detail == null) return fallback || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
